import { render, staticRenderFns } from "./authorityManagement.vue?vue&type=template&id=06cc1156&scoped=true&"
import script from "./authorityManagement.vue?vue&type=script&lang=js&"
export * from "./authorityManagement.vue?vue&type=script&lang=js&"
import style0 from "./authorityManagement.vue?vue&type=style&index=0&id=06cc1156&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cc1156",
  null
  
)

component.options.__file = "authorityManagement.vue"
export default component.exports